/** Die elf Standardrollen, die jeder neue Mandant erhält. */
export const DEFAULT_ROLES = [
    {
        key: 'platform_admin',
        name: 'Plattformadministrator',
        description: 'Verwaltet Mandanten der gesamten Installation.',
        audience: 'INTERNAL',
        permissions: ['*'],
        platformOnly: true,
    },
    {
        key: 'tenant_admin',
        name: 'Mandantenadministrator',
        description: 'Konfiguriert die eigene Organisation vollständig.',
        audience: 'INTERNAL',
        permissions: [
            'admin.*',
            'dashboard.*',
            'customers.*',
            'tickets.*',
            'repairs.*',
            'devices.*',
            'forms.*',
            'calendar.*',
            'integrations.*',
            'monitoring.*',
            'contracts.*',
            'automations.*',
            'reports.*',
            'billing.*',
        ],
    },
    {
        key: 'management',
        name: 'Geschäftsführung',
        description: 'Lesender Gesamtüberblick inklusive Berichte.',
        audience: 'INTERNAL',
        permissions: [
            'dashboard.view',
            'admin.users.read',
            'admin.audit.read',
            'customers.read',
            'tickets.read',
            'repairs.read',
            'devices.read',
            'forms.read',
            'calendar.read',
            'monitoring.read',
            'contracts.read',
            'reports.read',
            'billing.read',
        ],
    },
    {
        key: 'accounting',
        name: 'Abrechnung',
        description: 'Buchhaltung: übernimmt abrechnungsbereite Vorgänge nach Powerbird.',
        audience: 'INTERNAL',
        permissions: [
            'dashboard.view',
            'customers.read',
            'tickets.read',
            'tickets.comment_internal',
            'repairs.read',
            'devices.read',
            'contracts.read',
            'reports.read',
            'billing.*',
        ],
    },
    {
        key: 'service_lead',
        name: 'Serviceleitung',
        description: 'Steuert Tickets, Reparaturen, Termine und Verträge.',
        audience: 'INTERNAL',
        permissions: [
            'dashboard.view',
            'admin.users.read',
            'customers.*',
            'tickets.*',
            'repairs.*',
            'devices.*',
            'forms.read',
            'calendar.*',
            'monitoring.*',
            'contracts.*',
            'automations.manage',
            'reports.read',
            'billing.read',
            'billing.release',
        ],
    },
    {
        key: 'sales_intake',
        name: 'Verkauf / Geräteannahme',
        description: 'Nimmt Geräte an und betreut Kunden am Tresen.',
        audience: 'INTERNAL',
        permissions: [
            'dashboard.view',
            'customers.read',
            'customers.create',
            'customers.update',
            'tickets.read',
            'tickets.create',
            'repairs.read',
            'repairs.intake',
            'repairs.handover',
            'devices.read',
            'devices.manage',
            'calendar.read',
            'forms.read',
        ],
    },
    {
        key: 'workshop_technician',
        name: 'Werkstatttechniker',
        description: 'Diagnose, Reparatur und Prüfung von Geräten.',
        audience: 'INTERNAL',
        permissions: [
            'dashboard.view',
            'customers.read',
            'tickets.read',
            'tickets.update',
            'tickets.comment_internal',
            'repairs.read',
            'repairs.work',
            'repairs.quotes',
            'devices.read',
            'devices.manage',
            'calendar.read',
            'forms.read',
            'billing.release',
        ],
    },
    {
        key: 'it_technician',
        name: 'IT-Support-Techniker',
        description: 'Bearbeitet IT-Tickets, Termine und Monitoring.',
        audience: 'INTERNAL',
        permissions: [
            'dashboard.view',
            'customers.read',
            'tickets.read',
            'tickets.create',
            'tickets.update',
            'tickets.assign',
            'tickets.comment_internal',
            'devices.read',
            'devices.manage',
            'calendar.*',
            'monitoring.*',
            'contracts.read',
            'forms.read',
            'billing.release',
        ],
    },
    {
        key: 'customer_admin',
        name: 'Kundenadministrator',
        description: 'Ansprechpartner eines Geschäftskunden mit Unternehmensübersicht.',
        audience: 'CUSTOMER',
        permissions: ['portal.*'],
    },
    {
        key: 'customer_employee',
        name: 'Kundenmitarbeiter',
        description: 'Mitarbeiter eines Geschäftskunden, sieht eigene Vorgänge.',
        audience: 'CUSTOMER',
        permissions: ['portal.access', 'portal.tickets.create'],
    },
    {
        key: 'private_customer',
        name: 'Privatkunde',
        description: 'Privatkunde mit Zugriff auf eigene Vorgänge.',
        audience: 'CUSTOMER',
        permissions: ['portal.access', 'portal.tickets.create', 'portal.quotes.approve'],
    },
];
//# sourceMappingURL=roles.js.map